<template lang="html">
  <dropdown class="form-control-dropdown">
    <btn class="form-control-decorations dropdown-toggle" :disabled="disabled" :class="{disabled: disabled}"><span class="dropdown-selected-body">
      <template v-if="hasSelected">
        <div class="selected-account-block account-block noselect">
          <div>
            <dropdown-account-currency-icon :currency="selectedAccount.currency"></dropdown-account-currency-icon>
          </div>
          <div>
            <div class="account-block__number">{{ selectedAccount.number }}</div>
            <div class="account-block__name__wrap">
              <dropdown-account-crypto-system-icon :account="selectedAccount"></dropdown-account-crypto-system-icon><span class="account-block__name">&laquo;{{selectedAccount.name}}&raquo;</span>
            </div>
          </div>
          <div class="account-block__balance">
            <div class="account-block__balance_amount">{{MoneyFormatFilter(selectedAccount.availBalance, selectedAccount.currency)}}</div>

            {{selectedAccount.currency}}
          </div>

          <!--div.text-align-right <strong>{{selectedAccount.availBalance|moneyFormat(selectedAccount.currency)}}</strong> {{selectedAccount.currency}}-->
          <div class="selected--clear-button" v-if="allowClear && selectedAccount">
            <a href="#" @click.prevent="onSelectValue(null)">
              <ClearIconSvg :height="20" />
            </a>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="placeholder">{{ placeholderText }}</div>
      </template></span>
      <span class="caret"></span>
    </btn>
    <template v-slot:dropdown>
      <template v-if="allowClear && selectedAccount">
        <li @click.prevent="onSelectValue(null)">
          <a class="dropdown-accounts__li__content__clear" href="#" @click.prevent>
            <ClearIconSvg :height="36" color="#666666"></ClearIconSvg>
            <div class="name">
              {{$t('Снять выбор')}}
            </div>
          </a>
        </li>
      </template>
      <li class="dropdown-accounts-list-item noselect" v-for="(account, key) in filteredAccounts" :class="liClass(account)" :key="'cap-account-li-' + account.number"><a @click.prevent="onSelectValue(account)" href="#">
        <div class="dropdown-accounts__li__content">
          <div class="account-block">
            <div>
              <dropdown-account-currency-icon :currency="account.currency"></dropdown-account-currency-icon>
            </div>
            <div>
              <div class="account-block__number">{{account.number}}</div>
              <div class="account-block__name__wrap">
                <dropdown-account-crypto-system-icon :account="account"></dropdown-account-crypto-system-icon><span class="account-block__name">&laquo;{{account.name}}&raquo;</span>
              </div>
            </div>
            <div class="account-block__balance">
              <div class="account-block__balance_amount">{{MoneyFormatFilter(account.availBalance, account.currency)}}</div>

              {{account.currency}}
            </div>
          </div>
        </div></a></li>
    </template>
  </dropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Dropdown, Btn } from 'uiv';
import { formatUnixDateFilter } from '@/models/filters/datetime';
import { MoneyFormatFilter } from '@/models/filters/money';
import { Account } from '@/models/finance/account';
import DropdownAccountCurrencyIcon from '@/components/forms/dropdown/DropdownAccountCurrencyIcon.vue';
import DropdownAccountCryptoSystemIcon from '@/components/forms/dropdown/DropdownAccountCryptoSystemIcon.vue';
import ClearIconSvg from "@/components/forms/dropdown/ClearIconSvg.vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";

@Component({
  name: 'dropdown-accounts',
  components: {ClearIconSvg, DropdownAccountCryptoSystemIcon, DropdownAccountCurrencyIcon, Dropdown, Btn },
  methods: {
    formatUnixDateFilter,
    MoneyFormatFilter,
  },
  filters: {
    tsFormat: formatUnixDateFilter,
    moneyFormat: MoneyFormatFilter,
  },
})
export default class DropdownAccounts extends Vue {
  @Prop({ required: true })
  accounts!: Account[]

  @Prop({ required: true })
  value!: string | Account | null

  @Prop({ default: false })
  selectionObject: boolean

  @Prop({ default: 'Выберите счет' })
  placeholder!: string

  @Prop({ default: false })
  disabled!: boolean

  @Prop({ default: null })
  currency: string | string[] | any

  @Prop({ default: false })
  allowClear!: boolean

  @Prop({ default: false })
  includeCardsPro!: boolean


  get placeholderText(): string {
    return this.$t(this.placeholder) as string;
  }

  liClass(account: Account) {
    return {
      selected: this.selectedAccount && (this.selectedAccount.number === account.number),
    };
  }

  get filteredAccounts() {
    if (!this.accounts) return [];

    let result = this.accounts.filter((account: Account) => {
      return this.includeCardsPro || !account.isCardsPro;
    });

    if (this.currency) {
      if (typeof this.currency === 'string') {
        return result.filter((account: Account) => {
          return (account.currency === this.currency)
        });
      }
      if (Array.isArray(this.currency)) {
        return result.filter((account: Account) => {
          return (this.currency.indexOf(account.currency) >= 0);
        });
      }
    }
    return result;
  }

  get selectedAccount() {
    if (this.selectionObject && (typeof this.value === 'object') && this.value) return this.value;

    if (typeof this.value === 'string') {
      for (const account of this.accounts) {
        if (account.number == this.value) {
          return account;
        }
      }
    }
    return null;
  }

  get hasSelected() {
    return !!this.selectedAccount;
  }

  onSelectValue(val) {
    if (!val)
      this.$emit('input', null);
    else
      this.$emit('input', this.selectionObject ? val : val.number);
  }
}
</script>

<style scoped lang="less">
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


  .form-control-dropdown {
    ::v-deep {
      .selected--clear-button {
        display: flex;
        align-items: center;
        a {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .dropdown-menu li a.dropdown-accounts__li__content__clear {
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        justify-content: flex-start;
        font-weight: bolder;
        padding: 10px 15px;
        cursor: pointer;
        .name {
          color: #333333;
          font-size: 110%;
        }
      }
    }
  }


.scrollable() {
  /* Let's get this party started */
  &::-webkit-scrollbar {
    width: 8px;
    height: 13px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 4px;
    background: #d5e3b7;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 4px;
    border-radius: 4px;
    background: #80bd1c;
  }
  &::-webkit-scrollbar-thumb:window-inactive {
    background: #80bd1c;
  }
}

.form-control-dropdown {
  ::v-deep {
    .btn {
      float: none;
    }
    .dropdown-currency-icon, .dropdown-account-crypto-system-icon {
      //display: inline-block;
      margin-right: 5px;
      //font-size: 90%;

    }
  }
}
.form-control-decorations {
  .btn {
    float: none;
  }
  .caret {
    position: absolute;
    height: 5px;
    right: 15px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  min-height: 48px;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  &[disabled] {
    opacity: 1 !important;
    &.btn.btn-default {
      background-color: #eeeeee;
    }
  }
  &.btn.btn-default {
    background-color: rgb(242, 243, 248);
  }
}
.form-control-dropdown::v-deep {
  display: block;
  min-height: 48px;



  .dropdown-accounts__li__content {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap:  3px 8px;
    .content__name {
      grid-column-start: 1;
      grid-column-end: 3;
      font-size:85%;
    }
    .content__number, .content__amount {
      font-weight: bolder;
    }
    .content__amount {
      text-align: right;
    }
  }

  li.dropdown-accounts-list-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .account-block {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: max-content auto max-content;
    grid-auto-flow: column;
    grid-auto-columns: min-content;
    align-items: center;
    .account-block__number {
      font-weight: bold;
      font-size: 110%;
      line-height: 1em;
      padding-bottom: 3px;
    }
    .account-block__name {
      line-height: 1em;
      font-size: 90%;

      white-space: normal;
      word-break: break-word;
    }
    .account-block__name__wrap {
      line-height: 1em;
      .dropdown-account-crypto-system-icon {
        font-weight: bold;
      }
    }
    .account-block__balance {
      > div {
        display: inline-block;
      }
      .account-block__balance_amount {
        font-weight: bold;
      }
    }
  }

  .dropdown-selected-body {
    margin-right: 20px;
    display: block;

    .placeholder, .selected-account-block {
      padding: 3px 13px 0 0;
      margin: 6px 3px 10px 0;

    }
    .selected-account-block {
      border-right: 1px solid #ddd;
    }
    .selected-account-block {

      //&__row1 {
      //  display: grid;
      //  grid-gap: 15px;
      //  grid-template-columns: auto auto;
      //  align-content: space-between;
      //  justify-items: stretch;
      //  .text-align-right {
      //    text-align: right;
      //  }
      //}
      //&__row2 {
      //
      //}
      &__account-name {
        font-size: 90%;
        line-height: 1em;

      }
      &__account-number {
        > div {
          display: inline-block;
        }
      }
    }
  }

  .dropdown-toggle {
    text-align: left;
    //
    //&:after {
    //  content: "";
    //  display: block;
    //  width: 0;
    //  height: 0;
    //  border-style: solid;
    //  border-width: 5px 5px 0 5px;
    //  border-color: #333 transparent transparent transparent;
    //  position: absolute;
    //  right: 15px;
    //  top: 50%;
    //  -webkit-transform: translateY(-50%);
    //  transform: translateY(-50%);
    //}

    font-weight: 300;
    font-family: 'Proxima Nova Lt', sans-serif;
    position: relative;
    -webkit-box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    box-shadow: inset 0 2px 3px 0 rgba(0, 0, 0, 0.1);
    border: none;
    line-height: 30px;
    padding: 1px 15px 0;
    min-height: 36px;

    &:focus {
      border-color: #66afe9;
      outline: 0;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
    }
  }

  .dropdown-menu {
    top: 100%;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    .scrollable();
    padding: 10px 5px;
    box-sizing: border-box;

    li {
      padding: 0;
      margin: 0 0 0 0;

      a {
        padding: 5px 15px;
        &:hover {

        }
      }

      &.selected {
        background: #d7e5bd80;
      }

      &:hover {
        //background: #80bd1c;
        //color: #fff;

        a {
          font-weight: bolder;
          background: rgba(215, 229, 189, 0.71); //#80bd1c;
          color: #000;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Снять выбор": "Clear selection",
    "Выберите": "Please select",
    "Выберите счет": "Please select account"
  }
}
</i18n>
